import { PlayerDTO } from '@envclient/envcore';
import Player from '../../core/Player';
import { Meeple, MeepleDTO, MeepleType, MeepleTypeMap } from './Meeple';
import { Property, Type } from '@dipscope/type-manager';
import 'reflect-metadata';

@Type({ injectable: true, discriminant: 'MeepleSet' })
export class MeepleSet {
  @Property([Meeple])
  set: Set<Meeple> = new Set();
}

export interface TileBasePlayerDTO extends PlayerDTO {
  meeples: { [P in MeepleType]?: MeepleDTO[] };
  activeMeeples: MeepleDTO[];
}
